import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
//
import App from "./App";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

// ----------------------------------------------------------------------

// Fix for iOS Safari viewport height issues
const setViewportHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

// Set initial viewport height
setViewportHeight();

// Update on resize and orientation change
window.addEventListener("resize", setViewportHeight);
window.addEventListener("orientationchange", () => {
  setTimeout(setViewportHeight, 100);
});

// Prevent white bars on iOS by locking viewport
if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
  // Prevent zoom on double tap
  let lastTouchEnd = 0;
  document.addEventListener(
    "touchend",
    (event) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );

  // Lock viewport height
  const lockViewport = () => {
    const viewportHeight = window.innerHeight;
    document.documentElement.style.height = `${viewportHeight}px`;
    document.body.style.height = `${viewportHeight}px`;
  };

  lockViewport();
  window.addEventListener("resize", lockViewport);
  window.addEventListener("orientationchange", () => {
    setTimeout(lockViewport, 100);
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);

serviceWorkerRegistration.unregister();

reportWebVitals();
